<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header">
      {{protectionDataModal.title}}
    </span>
  </div>
  <div class="common-modal__content">
    @if(protectionDataModal.description){
      <p class="common-modal__content-header-info">{{protectionDataModal.description}}</p>
    }
    <div class="common-modal__form-container-extend">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <div class="protection-data-modal__translation-container">
        <div class="common-translations__container">
          <ul class="common-tab__tertiary-list-block">
            @for (selectedLanguage of protectionDataModal.protectionModalLanguagesSelected; track selectedLanguage.listValueId) {
              <li>
                <button [ngClass]="{'common-tab__tertiary--selected': selectedLanguage.active}"
                  (click)="changeActiveLanguagesSelected(selectedLanguage)"
                  class="common-tab__tertiary">
                  <p class="common-tab__tertiary-button-text"
                    [ngClass]="{'common-tab__tertiary-button-text--error': selectedLanguage.error}">
                    @if(protectionDataModal.protectionModalLanguagesSelected.length > 5){
                      {{selectedLanguage.appLanguage.substring(0, 2).toUpperCase()}}
                      }@else {
                      {{selectedLanguage.text}}
                    }
                  </p>
                  @if (!selectedLanguage.defaultOption) {
                    <button (click)="removeActiveLanguage(selectedLanguage)"
                      class="common-button__icon-xs-noborder">
                      <i class="lf-icon-close-thick common-icon__sm common-icon__neutral">
                      </i>
                    </button>
                  }
                </button>
              </li>
            }
            @if (protectionDataModal.protectionModalLanguagesApp.length !== protectionDataModal.protectionModalLanguagesSelected.length) {
              <li #selectLanguagesContainer>
                <button (click)="selectLanguagesDropdown.toggle($event, selectLanguagesContainer)"
                  class="common-tab__tertiary"
                  [ngClass]="{'common-tab__tertiary--active': openLanguagesDropdown}">
                  <p [afTranslate]="'protection-data-modal.add-translation'"
                    class="common-tab__tertiary-button-text">
                    _Añadir traducción
                  </p>
                  <i class="lf-icon-translate common-icon__md"></i>
                </button>
                <p-overlayPanel
                  #selectLanguagesDropdown
                  (onShow)="openLanguagesDropdown = true"
                  (onHide)="openLanguagesDropdown = false"
                  styleClass="common-dropdown-overlay__container">
                  <ng-template pTemplate="content">
                    <div class="common-dropdown__items-container">
                      @for (language of protectionDataModal.protectionModalLanguagesApp; track language.listValueId) {
                        @if (notSelectLanguage(language)) {
                          <button
                            (click)="selectLanguage(language.listValueId, selectLanguagesDropdown)"
                            class="common-dropdown-list__si-button">
                            <span-tooltip
                              class="common-dropdown-list__si-text-container"
                              [text]="language.text"
                              [tooltipPosition]="'top'">
                            </span-tooltip>
                          </button>
                        }
                      }
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </li>
            }
          </ul>
        </div>
        <field-type-rich-text-editable class="w-[100%]"
          [field]="protectionDataModal.protectionModalDataTreatment"
          [preSelectItem]="protectionDataModal.protectionModalDataTreatmentText"
          (itemSelected)="itemSelect($event)">
        </field-type-rich-text-editable>
      </div>
    </div>
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()" >
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">
        _cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="validateFields()">
      <span class="common-button__text-title"
        [afTranslate]="'common.save'">
      </span>
    </button>
  </div>
</div>
